function SearchGastops(){
    jQuery(function() {
        jQuery("#gastops__search").click(function(e){
            e.preventDefault();
            jQuery(".gastops__search-wrap").slideDown();
        });

        jQuery("#gastops__search-close").click(function(e){
            e.preventDefault();
            jQuery(".gastops__search-wrap").slideUp();
        });

        jQuery(".gastops__search-prefix").click(function(e){
            e.preventDefault();
            jQuery(".gastops__search-form").submit();
        });
    });

}

export default SearchGastops ;